import { useQuery } from '@tanstack/react-query';
import { getUpdateDay, listUpdates, type UpdateDayResponse, type UpdateSummary } from '../api/updates';

export function useUpdatesList() {
  return useQuery<UpdateSummary[]>({ queryKey: ['updates', 'list'], queryFn: listUpdates, retry: false });
}

export function useUpdateDay(date: string | null) {
  return useQuery<UpdateDayResponse>({
    queryKey: ['updates', 'day', date],
    queryFn: () => getUpdateDay(date as string),
    enabled: Boolean(date),
    retry: false,
  });
}
